import React, {Component} from "react";
import {
    BILATERAL_CONTROL_PANEL_ROUTE
} from "../../../../utils/constants/RoutesConstants";
import BilateralExcess from "./BilateralExcessView";
import {Growl} from "primereact/growl";
import {BilateralLoanService} from "../../../../service/bilateral/loan/BilateralLoanService";
import PropTypes from "prop-types";
import {amountCalculate} from "../../../../utils/formatters/Numbers";
import {ExcessLoanService} from "../../../../service/bilateral/loan/ExcessLoanService";

export default class BilateralExcessContainer extends Component {
    constructor(props) {
        super(props);

        this.bilateralLoanService = new BilateralLoanService();
        this.excessLoanService = new ExcessLoanService();
        this.getDetailLoan = this.getDetailLoan.bind(this);
        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveExcess = this.saveExcess.bind(this);
        this.bilateralLoanData = React.createRef();
        this.bilateralAssignedCollateral = React.createRef();

        this.state = {
            isLoading: true,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            loanId: this.props.location.state.selectedLoanControlPanel.id,
            collateralDetail: {}
        };
    };


    componentDidMount() {
        let loanId = this.props.location.state.selectedLoanControlPanel.id;
        this.getDetailLoan(loanId);
    }

    getDetailLoan(loanId){
        this.bilateralLoanService.getLoanDetail(loanId, true)
            .then( res => {
                if (this.validResponse(res)){
                    this.setState({
                        selectedLoan: res.data,
                        collateralDetail: res.data.collateralDetail
                    });
                    this.setLoanDetail(res.data);
                    this.setCollateralDetail(res.data.collateralDetail ?? {});
                    this.loading(false);
                }
            });
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }

    setLoanDetail(loanData) {
        this.bilateralLoanData.current.state.selectedLoan = loanData ;
        this.bilateralLoanData.current.getLoan();
        this.bilateralAssignedCollateral.current.state.loanAmount = loanData['amount'];
    }
    setCollateralDetail(collateralData) {
        this.bilateralAssignedCollateral.current.state.collateralDetail = collateralData;
        this.bilateralAssignedCollateral.current.setCollateralDetail();
        this.bilateralAssignedCollateral.current.calculateSuggested();
    }


    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: BILATERAL_CONTROL_PANEL_ROUTE,
            message:message,
        });
    }

    saveExcess() {
        let unassignedCollateralList =  this.getCollateralListFromMap(
            this.bilateralAssignedCollateral.current.state.collateralToUnassignMap);

        if (this.canSaveExcess(unassignedCollateralList.length)) {
            this.loading(true);

            let params = {
                loanId: this.state.selectedLoan.id,
                collateralMovementList: unassignedCollateralList,
            };
            this.excessLoanService.unassignCollaterals(params).then(
                res => {
                    if (this.validResponse(res)) {
                        this.loading(true);
                        this.handleReturnButton({
                            severity: 'success',
                            sumary: 'Éxito',
                            detail: 'Las garantías han sido guardadas exitosamente',
                        });
                    }
                });
        }
    }

    canSaveExcess(collateralUnassignedLength) {
        if ((this.state.selectedLoan.amount >
            amountCalculate(this.bilateralAssignedCollateral.current.state.guaranteedAmount))
            || (collateralUnassignedLength === 0)) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar las garantías"});
            return false;
        }
        return true;
    }

    getCollateralListFromMap(collateralMap) {
        let collateralList =[];
        for (const [key, value] of collateralMap) {
            collateralList.push({
                instrumentId: key,
                title: value
            });
        }
        return collateralList;
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <BilateralExcess
            isLoading={this.state.isLoading}
            bilateralLoanData={this.bilateralLoanData}
            messagesGrowl={messagesGrowl}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            saveExcess={this.saveExcess}
            selectedLoan={this.state.selectedLoan}
            bilateralAssignedCollateral={this.bilateralAssignedCollateral}
            collateralDetail={this.state.collateralDetail}
        />

    }
};

BilateralExcessContainer.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};